const obj = {
    //个性化设置
    getIndividuation(name, arr) {
        let info = window.localStorage.getItem(name);
        if (info) {
            return JSON.parse(info);
        } else {
            let res = arr.map(item => {
                return item.label;
            })
            return res;
        }
    },
    setIndividuation(name, arr) {
        let str = JSON.stringify(arr);
        window.localStorage.setItem(name, str)
    },
    //去掉参数为空字段
    dealParam(data) {
        let obj = {}
        for (let key in data) {
            if (data[key] !== "") {
                obj[key] = data[key]
            }
        }
        return obj
    },
    //文件转base64
    getBase64(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let fileResult = "";
            reader.readAsDataURL(file);
            //开始转
            reader.onload = function () {
                fileResult = reader.result;
            };
            //转 失败
            reader.onerror = function (error) {
                reject(error);
            };
            //转 结束  咱就 resolve 出去
            reader.onloadend = function () {
                resolve(fileResult);
            };
        });
    },
    //生成excel文件
    buildExcel(data, name) {
        let str = '';
        data.forEach(ele => {
            ele.forEach((item, index) => {
                if (ele.length - 1 == index) {
                    str += `${item}\n`
                } else {
                    str += `${item},`
                }
            })
        })
        // let url = 'data:text/txt;charset=utf-8,\ufeff'+str;
        let url = new Blob(['\ufeff' + str], { type: "text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let oEl = document.createElement('a');
        // oEl.setAttribute('href', url);
        oEl.href = URL.createObjectURL(url);
        if (name) {
            oEl.setAttribute('download', name)
        }
        let evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, true);
        oEl.dispatchEvent(evt);
    },
    getRegionName(regionList, id) {
        let item = regionList.find(it => {
            return it.id == id
        })
        if (item) {
            return item.name
        } else {
            return ""
        }
    },
    dealExamPlace(arr) {
        let realArr = arr.filter(item => {
            return item.name || item.number || item.theme
        })
        return JSON.stringify(realArr)
    },
    //根据ID查区域其他属性值
    getRegionNameById(id,type){
        let regionListAll = JSON.parse(window.localStorage.getItem('regionListAll'))
        return regionListAll[id-1][type]
    },
    dealRegionAll(list) {
        let arr = [];
        let obj1 = {};
        let obj2 = {};
        list.forEach(item => {
            if (item.region_level == 1) {
                item.value = item.id;
                item.label = item.name;
                item.children = [];
                arr.push(item)
                obj1[item.region_number] = item;
            } else if (item.region_level == 2) {
                item.value = item.id;
                item.label = item.name;
                item.children = [];
                obj2[item.region_number] = item;
            } else if (item.region_level == 3) {
                item.value = item.id;
                item.label = item.name;
                obj2[item.region_parent_id].children.push(item)
            }
        })
        for (let key in obj2) {
            let item = obj2[key];
            if (item.children.length == 0) {
                delete item.children;
            }
            obj1[item.region_parent_id].children.push(item)
        }
        for (let key in obj1) {
            arr.push(obj1[key])
        }
        return arr
    },
    dealRegionPlace(list){
        list.forEach(it=>{
            it.value = it.id;
            it.label = it.name;
            if(it.place){
                it.children = this.dealRegionPlace(it.place)
            }else if(it.children){
                it.children = this.dealRegionPlace(it.children)
            }
        })
        return list;
    }
    // dealRegionPlace(list) {
    //     let arr = [];
    //     let regionListAll = JSON.parse(window.localStorage.getItem('regionListAll'))
    //     let obj1 = {}, obj2 = {};
    //     list.forEach(item => {
    //         if(item.place.length>0){
    //             if (!obj2[item.region_parent_id]) {
    //                 obj2[item.region_parent_id] = regionListAll[item.region_parent_id - 1000000];
    //                 obj2[item.region_parent_id].children = [];
    //             }
    //             item.value = item.id;
    //             item.label = item.name;
    //             item.children = item.place.map(it=>{
    //                 let obj4 = {
    //                     value: it.place_id,
    //                     label: it.name
    //                 }
    //                 return obj4
    //             })
    //             obj2[item.region_parent_id].children.push(item);
    //         }
    //     })
    //     for (let key in obj2) {
    //         let item = obj2[key];
    //         if (!obj1[item.region_parent_id]) {
    //             obj1[item.region_parent_id] = regionListAll[item.region_parent_id - 1000000];
    //             obj1[item.region_parent_id].children = [];
    //         }

    //         item.value = item.id;
    //         item.label = item.name;
    //         obj1[item.region_parent_id].children.push(item)
    //     }
    //     for (let key in obj1) {
    //         let item = obj1[key]
    //         item.value = item.id;
    //         item.label = item.name;
    //         arr.push(item)
    //     }
    //     console.log(arr)
    //     return arr
    // }
}
export default obj;


// WEBPACK FOOTER //
// ./src/utils/index.js